'use client';
/** Alias для Math.min */ const min = Math.min;
/** Alias для Math.max */ const max = Math.max;
/** Alias для Math.round */ const round = Math.round;
/** Alias для Math.floor */ const floor = Math.floor;
/** Alias для Math.ceil */ const ceil = Math.ceil;
/** Alias для Math.abs */ const abs = Math.abs;
/** Alias для Math.trunc */ const trunc = Math.trunc;

export { abs, ceil, floor, max, min, round, trunc };
//# sourceMappingURL=math.js.map
